/**
 * Main GEN_Custom scripts
 */

// Load script files with gulp-include
//=require inc/functions.js
